import { render } from "./view.vue?vue&type=template&id=e8b59ea2"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"
script.render = render

export default script